export default "__VITE_PUBLIC_ASSET__f32abbe0__"